export enum JobStatus {
  OPEN = 'OPEN',
  PAUSED = 'PAUSED',
  FILLED = 'FILLED',
  CLOSED = 'CLOSED',
  DRAFT = 'DRAFT',
}
